// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import axios from 'axios'
import 'element-ui/lib/theme-chalk/index.css'
// vant css
import 'vant/lib/index.css'
// 引入 iocntont
import '@/assets/css/iconfont.css'
// 引入rem文件
import '@/config/rem'

// 引入无缝滚动插件
import scroll from 'vue-seamless-scroll'
Vue.use(scroll)

Vue.use(ElementUI)
// Vue.use(eslint);

Vue.prototype.$axios = axios

Vue.config.productionTip = false

Vue.prototype.resetSetItem = function (key, newVal) {
  if (key === 'navigation') {
    // 创建一个StorageEvent事件
    var newStorageEvent = document.createEvent('StorageEvent')
    const storage = {
      setItem: function (k, val) {
        sessionStorage.setItem(k, val)
        // 初始化创建的事件
        newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null)
        // 派发对象
        window.dispatchEvent(newStorageEvent)
      }
    }
    return storage.setItem(key, newVal)
  }
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js